
function updateSignatureToogle(elem) {

    let signatureSection = document.getElementById('signatureSection');

    let checked;
    if (elem.checked) {
        checked = 1;
        signatureSection.classList.add('signatureDisplayed');
        signatureSection.classList.remove('signatureHidden');
    } else {
        checked = 0;
        signatureSection.classList.add('signatureHidden');
        signatureSection.classList.remove('signatureDisplayed');
    }

    $.ajax({
        type: 'PUT',
        url: '/message/signature/update',
        data: {
            "checked": checked
        },
        success: function () {
        }
    });
}


window.updatePoints = function(pointsToAdd) {

    let pointsElement = document.querySelector('.header_points');

    if (pointsElement) {
        let currentPoints = parseInt(pointsElement.textContent);
        pointsElement.textContent = currentPoints + parseInt(pointsToAdd);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/used_on_multiple_pages.js